import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { SectorsService } from '../sectors.service';

@Component({
  selector: 'app-sectors-detail',
  templateUrl: './sectors-detail.component.html',
  styleUrls: ['./sectors-detail.component.scss']
})
export class SectorsDetailComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public sector: any = {};
  constructor(
    private sectorsService: SectorsService,

    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.loadData(this.config.data.id);
  }
  loadData(id) {
    if (id) {
      this.sectorsService.get(id).subscribe(
        data => {
          this.sector = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.sector.id === "undefined") {
      this.sectorsService.add(this.sector).subscribe(
        data => {
          this.sector = data;
          this.loadData(this.sector.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Sector añadido correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.sectorsService.save(this.sector.id, this.sector).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Sector guardado correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el sector " + this.sector.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.sectorsService.delete(this.sector.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  onEvent(event) {
    if (event.component == "sector.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.save(event);
    }
  }
}
